import breadcrumb from "@/lib/breadcrumb";
import i18n from "@/lib/i18n";
import router from "@/lib/router";

export default {
	install() {
		i18n.mergeLocaleMessage("fr", {
			"breadcrumb.controls.dsn.definitions": "Contrôles de syntaxe de DSN",
			"breadcrumb.controls.dsn.definitions.fields.view": "Définition de rubrique de DSN",
			"breadcrumb.controls.dsn.definitions.view": "Définition de DSN",
		});

		breadcrumb.add([
			{
				path: "/database/controls/dsn/definitions",
				name: "home>database>controls.dsn.definitions"
			},
			{
				path: "/database/controls/dsn/definitions/([0-9]+)",
				replacePath: "/database/controls/dsn/definitions/{1}",
				name: "home>database>controls.dsn.definitions>controls.dsn.definitions.view"
			},
			{
				path: "/database/controls/dsn/definitions/([0-9]+)/(S[0-9]{2}.G[0-9]{2}.[0-9]{2}).([0-9]{3})",
				name: "home>database>controls.dsn.definitions>controls.dsn.definitions.view>controls.dsn.definitions.fields.view"
			}
		]);

		router.addRoutes([
			{
				path: "/database/controls/dsn/definitions",
				name: "controls.dsn.definitions",
				component: () => import("./vues/DsnDefinitionList.vue"),
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/controls/dsn/definitions/:version(P\\d\\dV\\d\\d)",
				name: "controls.dsn.definitions.view",
				component: () => import("./vues/DsnDefinitionView.vue"),
				props: true,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			},
			{
				path: "/database/controls/dsn/definitions/:dsnVersion(P\\d\\dV\\d\\d)/:blockCode(S\\d{2}.G\\d{2}.\\d{2}).:fieldCode(\\d{3})",
				name: "controls.dsn.definitions.fields.view",
				component: () => import("./vues/DsnFieldDefinitionView.vue"),
				props: true,
				meta: {
					secured: true,
					roles: ["DATABASE_ADMINISTRATOR"]
				}
			}
		]);
	}
};
